import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiResponse, ResponseStatus, PayloadResponse } from '../models/response.model';
import { HistoryRequest, HistoryResponse, AddTags } from '../models/telemed.model';
@Injectable({
  providedIn: 'root'
})
export class ClaimService {

  constructor(private http: HttpClient) { }
  apiRegisterClaim(body): Observable<any> {
    return this.http.post<any>(environment.endpointBackend + '/api/line/claim/registerClaim', body).pipe(
      map(
        payload => {
          switch (payload.response_code) {
            case ('40000'):
              return payload
            default:
              return null
          }
        }
      )
    )
  }
}
